export default {
  ResultSummary: 'PSARS',
  SubArea: 'WithoutSubArea',
  Procedure: 'WithoutProcedure',
  Necessity: 'WithoutNecessity',
  Strength: 'WithoutStrength',
  Level: 'WithoutLevel',
  GoalsCountError: 'GoalsCountError',
  GoalWithoutObjetive: 'WithoutObjective',
  GoalWithoutNecessity: 'GoalWithoutNecessity',
  SubAreaWithoutGoal: 'SubaAreaWithoutGoal',
  NecessitySelection: 'IncompleteNecessitiesSelection',
  CompensationServiceInvalid: 'CompensationServiceInvalid',
  EducationalCompensationCurrentServiceUnanswered:
    'EducationalCompensationCurrentServiceUnanswered',
  EducationalCompensationPreviousServiceUnanswered:
    'EducationalCompensationPreviousServiceUnanswered',
  isYesSelectedOnCurrentWithoutServices:
    'isYesSelectedOnCurrentWithoutServices',
  isYesSelectedOnPreviousWithoutServices:
    'isYesSelectedOnPreviousWithoutServices',
  isNoSelectedOnCurrentWithServices: 'isNoSelectedOnCurrentWithServices',
  hasAtLeastOneDocumentedWhenYes: 'hasAtLeastOneDocumentedWhenYes',
  hasAtLeastOneDocumentedWhenNo: 'hasAtLeastOneDocumentedWhenNo',
};
